import { Code, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconWebhook } from "@tabler/icons-react";
import SectionCard from "./SectionCard";
import {
  webhookPayloadTextExample,
  webhookPayloadWithImageExample,
} from "../webhookPayloads";

const WebhookSection = () => {
  const theme = useMantineTheme();
  const iconColor = theme.colors.R500?.[0];

  return (
    <SectionCard
      title="Eventos de Webhook"
      icon={
        <IconWebhook
          size={20}
          color={iconColor}
          aria-hidden
        />
      }>
      <Stack gap="sm">
        <Text c={theme.colors.plain_text[0]}>
          Este webhook só é enviado se a feature de Webhook estiver ativada na
          aba &quot;Avançado&quot; e se houver um webhook ativo configurado.
          Somente conversas atendidas pela IA geram eventos enviados para a sua
          URL.
        </Text>
        <Text
          size="sm"
          c={theme.colors.plain_text[0]}>
          Abaixo está o formato do payload quando o cliente envia uma mensagem
          sem imagem:
        </Text>
        <Code
          block
          style={{ overflowX: "auto", width: "100%" }}>
          {webhookPayloadTextExample}
        </Code>
        <Text
          size="sm"
          c={theme.colors.plain_text[0]}>
          Quando a mensagem contém imagem, o conteúdo inclui a transcrição e os
          detalhes de mídia:
        </Text>
        <Code
          block
          style={{ overflowX: "auto", width: "100%" }}>
          {webhookPayloadWithImageExample}
        </Code>
      </Stack>
    </SectionCard>
  );
};

export default WebhookSection;
